// Libraries
import { Box, Link, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import classNames from "classnames";
import { useObserver } from "mobx-react-lite";
import React, { ReactElement } from "react";
import ReactHtmlParser from "react-html-parser";

// Core
import { isEmptyOrWhitespace } from "../../../../Core/Utils/Utils";

// Custom
import { BQSSelectStyle } from "./../BQSPrimitivesStyle";
import { isNullOrUndefined } from "Custom/Utils/Utils";

interface IProps {
    className?: string;
    disableClearable?: boolean;
    displayName: string;
    execute: (value: any) => void;
    getOptionLabel: (option: any) => string;
    groupBy?: (option: any) => string;
    canExecute?: boolean;
    options: any[];
    value: any;
    validationMessage?: string;
    showColourLink?: boolean;
}

export const BQSSelect: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const selectClasses = BQSSelectStyle();

    const getClassName = (): string => {
        return classNames({
            BQSSelect: true,
            [`${props.className}`]: !isEmptyOrWhitespace(props.className),
        });
    };

    const showColourPDFLink: boolean = props.showColourLink === undefined || props.showColourLink === null ? false : props.showColourLink;

    const getDisplayName = (): React.ReactNode => {
        if (showColourPDFLink === false) {
            return !isEmptyOrWhitespace(props.displayName) ? ReactHtmlParser(props.displayName) : "";
        } else {
            const displayName: any = !isEmptyOrWhitespace(props.displayName) ? ReactHtmlParser(props.displayName) : "";

            return (
                <Box>
                    {displayName}&nbsp;(
                    <span style={{ color: "red" }}>
                        <Link href="https://www.hdsharman.co.uk/wp-content/uploads/2023/05/Coatings-Colour-Chart-020323.pdf" target="_blank">
                            coatings chart
                        </Link>
                    </span>
                    )
                </Box>
            );
        }
    };

    /*     const getCoatingsChart = (): ReactElement<any, string | any> => {
        return showColourPDFLink == true ? (
            <Box className={delcoteProductsStyle.specificationLink}>
                <Link href="https://www.hdsharman.co.uk/wp-content/uploads/2023/05/Coatings-Colour-Chart-020323.pdf" target="_blank">
                    (Coatings chart)
                </Link>
            </Box>
        ) : (
            ""
        );
    }; */

    const getValidationMessage = (): string => {
        return !isEmptyOrWhitespace(props.validationMessage) ? props.validationMessage! : "";
    };

    const isClearableDisabled = (): boolean => {
        return !isNullOrUndefined(props.disableClearable) ? props.disableClearable : false;
    };

    const isDisabled = (): boolean => {
        return !isNullOrUndefined(props.canExecute) ? !props.canExecute : false;
    };

    const isValidationMessageNotEmpty = (): boolean => {
        return !isEmptyOrWhitespace(props.validationMessage);
    };

    const onChange = (e: any, value: any): void => {
        props.execute(value);
    };

    // #endregion Code Behind

    // #region Public Interface

    return useObserver(() => (
        <Autocomplete
            classes={selectClasses}
            className={getClassName()}
            disableClearable={isClearableDisabled()}
            disabled={isDisabled()}
            getOptionLabel={props.getOptionLabel}
            groupBy={props.groupBy}
            onChange={onChange}
            options={props.options}
            renderInput={(params: any) => (
                <TextField
                    {...params}
                    error={isValidationMessageNotEmpty()}
                    helperText={getValidationMessage()}
                    InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    label={getDisplayName()}
                />
            )}
            value={props.value}
        />
    ));

    // #endregion Public Interface
};
